import { render, staticRenderFns } from "./VerificationSubscriptionDetails.vue?vue&type=template&id=ae1876fc&"
import script from "./VerificationSubscriptionDetails.vue?vue&type=script&lang=js&"
export * from "./VerificationSubscriptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports